import { render, staticRenderFns } from "./IndividuellesDetailPage.vue?vue&type=template&id=258adc02&scoped=true&"
import script from "./IndividuellesDetailPage.vue?vue&type=script&lang=js&"
export * from "./IndividuellesDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./IndividuellesDetailPage.vue?vue&type=style&index=0&id=258adc02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258adc02",
  null
  
)

export default component.exports